<div class="parent-content">
	<div class="content" ngClass="{{ toasterClass }}" *ngIf="toastTypeNumber==0">
		<img src="{{imageBasePath}}assets/img/Persistence/saved.svg" class="icon" alt='saved'>
		<span class="title">
			{{ 'FOC._COMMON_ACROSS_PAGES.TOASTS.CHANGES_SAVED_AUTOMATICALLY' | translate }}
		</span>
	</div>
	<div class="content" ngClass="{{ toasterClass }}" *ngIf="toastTypeNumber==1">
		<div class="loader">
		</div>
		<span class="title">
			{{ 'FOC._COMMON_ACROSS_PAGES.TOASTS.LOAD_DRAWINGS' | translate }}
		</span>
	</div>
	<div class="content" ngClass="{{ toasterClass }}" *ngIf="toastTypeNumber==2">
		
		<img src="{{imageBasePath}}assets/img/Persistence/error.svg" class="icon" alt='error'>
		<span class="title">
			{{ 'FOC._COMMON_ACROSS_PAGES.NOTES.FAILED_NOTES' | translate }}
		</span>
	</div>
	<div class="content" ngClass="{{ toasterClass }}" *ngIf="toastTypeNumber==3">
		<img src="{{imageBasePath}}assets/img/Persistence/error.svg" class="icon" alt='error'>
		<span class="title">
			{{ 'FOC._COMMON_ACROSS_PAGES.TOASTS.FAILED_DRAWINGS' | translate }}
		</span>
	</div>
	<div class="content" ngClass="{{ toasterClass }}" *ngIf="toastTypeNumber==4">
		<img src="{{imageBasePath}}assets/img/Persistence/warning.svg" class="icon" alt='warning'>
		<span class="title">
			{{ 'FOC._COMMON_ACROSS_PAGES.TOASTS.SAVING_FAILED' | translate }}
		</span>
	</div>
	<div class="content" ngClass="{{ toasterClass }}" *ngIf="toastTypeNumber==5">
		<div class="d-flex">
			<img src="{{imageBasePath}}assets/img/Persistence/warning.svg" class="icon" alt='warning'>
			<div>
				<div class="title">
					{{ 'FOC._COMMON_ACROSS_PAGES.TOASTS.HIDEBOX.TITLE' | translate:{maskLimit: toast.maskLimit} }}
				</div>
				<div class="description">
					{{ 'FOC._COMMON_ACROSS_PAGES.TOASTS.HIDEBOX.DESCRIPTION' | translate }}
				</div>
			</div>
			<button class="close-btn" (click)="hideToast()"
				[attr.aria-label]="'FOC._COMMON_ACROSS_PAGES.TIP_MODAL.PDZ.SCREEN_READER.CLOSE_BTN_ARIA_LABEL' | translate">
				&times;
			</button>
		</div>
	</div>
</div>